var _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEmpSync = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#EEF2FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 27C26.0711 27 27.75 25.3211 27.75 23.25C27.75 21.1789 26.0711 19.5 24 19.5C21.9289 19.5 20.25 21.1789 20.25 23.25C20.25 25.3211 21.9289 27 24 27Z",
    stroke: "#235AF3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9812 30.6909C18.5455 29.5794 19.4065 28.6459 20.4689 27.9938C21.5313 27.3418 22.7534 26.9966 24 26.9966C25.2465 26.9966 26.4686 27.3418 27.531 27.9938C28.5934 28.6459 29.4544 29.5794 30.0187 30.6909",
    stroke: "#235AF3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.75 24L33 26.25L35.25 24",
    stroke: "#235AF3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 24L15 21.75L17.25 24",
    stroke: "#235AF3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.75V24C14.9993 25.9055 15.6034 27.762 16.7252 29.3022C17.8471 30.8424 19.4289 31.9868 21.2427 32.5706C23.0566 33.1543 25.0089 33.1474 26.8185 32.5506C28.6282 31.9539 30.2017 30.7982 31.3125 29.25",
    stroke: "#235AF3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33 26.2501V24.0001C33.0007 22.0946 32.3966 20.238 31.2748 18.6978C30.1529 17.1576 28.5711 16.0132 26.7573 15.4295C24.9434 14.8457 22.9911 14.8527 21.1815 15.4494C19.3718 16.0462 17.7983 17.2019 16.6875 18.7501",
    stroke: "#235AF3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmpSync, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/empSync.3a3f3e13.svg";
export { ForwardRef as ReactComponent };